import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Sidebar from './Sidebar';
import './Layout.css';

const Layout = ({ children }) => {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Close mobile menu on route change
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  // Close mobile menu on escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        setMobileMenuOpen(false);
      }
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, []);

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [mobileMenuOpen]);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <div className={`layout ${mobileMenuOpen ? 'mobile-menu-open' : ''}`}>
      {/* Mobile overlay */}
      {mobileMenuOpen && (
        <div className="mobile-overlay" onClick={() => setMobileMenuOpen(false)} />
      )}
      <Sidebar mobileMenuOpen={mobileMenuOpen} />
      <div className="layout-main">
        <header className="layout-header">
          <div className="layout-header-content">
            <div className="layout-header-left">
              <button
                className="mobile-menu-button"
                onClick={toggleMobileMenu}
                aria-label="Toggle menu"
              >
                {mobileMenuOpen ? '✕' : '☰'}
              </button>
              <img src="/chulas.png" alt="Chula's Logo" className="header-logo" />
              <h1>Admin Portal</h1>
            </div>
            <div className="layout-header-actions">
              <span className="current-user">
                {user?.signInDetails?.loginId || 'Admin'}
              </span>
              <button onClick={handleLogout} className="logout-button">
                Sign Out
              </button>
            </div>
          </div>
        </header>
        <main className="layout-content">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
